import { compact, keys } from 'lodash';
import values from 'lodash/values';
import moment from 'moment';
import { ICartExperience } from 'types/cart';
import { formatBulkBookingCartItemsData } from 'actions/booking';
import { CreditCodes } from 'types/credit-codes';

type Props = {
  cartItems: Record<string, ICartExperience>;
  purchaserFirstName?: string;
  purchaserLastName?: string;
  discountCode?: {
    experienceIds: string[];
    code: string;
  };
  creditCodes?: CreditCodes['creditCodes'];
  selectedRecommendation?: {
    experienceId: string;
    resourceGroupCollectionId?: string;
    recommendationId: string;
  } | null;
};

export const getCartItemsData = ({
  cartItems,
  purchaserFirstName,
  purchaserLastName,
  discountCode,
  creditCodes,
  selectedRecommendation,
}: Props) => {
  const items = values(cartItems).map((item) => {
    const additionalCustomQuestionResponses = compact(
      keys(item.additionalCustomQuestionResponses).map((key) => ({
        questionId: key,
        answer: item.additionalCustomQuestionResponses[key] || [],
      })),
    );
    const participants = item.participants.map((data) => {
      const p = {
        ...data,
        ...(data.fullName === 'Resource Purchaser' &&
        purchaserFirstName &&
        purchaserLastName
          ? {
              firstName: purchaserFirstName,
              lastName: purchaserLastName,
              fullName: `${purchaserFirstName} ${purchaserLastName}`,
            }
          : null),
      };

      if (!p.customQuestionResponses) {
        return p;
      }

      const customQuestionResponses = compact(
        keys(p.customQuestionResponses),
      ).map((key) => ({
        questionId: key,
        answer: p.customQuestionResponses?.[key] || [],
      }));

      return {
        ...p,
        customQuestionResponses,
      };
    });

    const matchesRecommendation =
      selectedRecommendation &&
      (item.experienceId === selectedRecommendation.experienceId ||
        (item.resourceGroupCollectionId &&
          selectedRecommendation.resourceGroupCollectionId &&
          item.resourceGroupCollectionId ===
            selectedRecommendation.resourceGroupCollectionId));

    return {
      ...item,
      sessionDuration: moment.duration(item.sessionDuration).asMinutes(),
      additionalCustomQuestionResponses,
      participants,
      ...(matchesRecommendation && {
        recommendationId: selectedRecommendation.recommendationId,
      }),
    };
  });

  return formatBulkBookingCartItemsData(items, discountCode, creditCodes);
};
